import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { RoutePermissions, TypedRoute } from '../app-routing.module';
import { User } from '../models/user';
import { UserLogin } from '../models/userlogin';
import { LoginService } from '../services/login.service';
import { NotificationService } from '../services/notification.service';

// export interface RoutePermissions {
//   RouteAccessLevel: 'Admin';
// }

export interface TypedRouteSnapshot extends ActivatedRouteSnapshot {
  data: RoutePermissions;
}

@Injectable({
  providedIn: 'root',
})
export class UserGuard implements CanActivate {
  User!: UserLogin | null;
  NotAuthorizedMsg = {
    Type: "danger",
    Message: "Please login",
    Body: `This route requires you to be logged in.`
  }
  constructor(private router: Router, private notificationService: NotificationService, private loginService: LoginService) {

    const localStringUser = localStorage.getItem('currentUser');
    let localUser: UserLogin | null = null;

    if (localStringUser) {
      localUser = <UserLogin>JSON.parse(localStringUser);
      this.User = localUser;
    }

    this.loginService.User.subscribe(x => {
      if (x) this.User = x
    });
  }

  canActivate(
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {

    if (!this.User) {
      this.notificationService.Notifications.next(this.NotAuthorizedMsg);
      this.router.navigate(['/login']);

      return false;
    }

    return true;
  }
}
